import { Route, Routes } from "react-router-dom";
import Login from "../pages/Login/Login";
import PrivateRoute from "./PrivateRoute";
import DashboardLayout from "../layouts/DashBoardLayout";
import Users from "../pages/Users/Users";
import Orders from "../pages/Orders/Orders";
import Courses from "../pages/Courses/Courses";
import Classes from "../pages/Classes/Classes";
import Events from "../pages/Events/Events";
import Coupons from "../pages/Coupons/Coupons";
import Plans from "../pages/Plans/Plans";
import Subscriptions from "../pages/Subscriptions/Subscriptions";
import Chapters from "../pages/Courses/Chapters";
import Lessons from "../pages/Courses/Lessons";
import QueryLeads from "../pages/Queries/QueryLeads";
import EqTestLeads from "../pages/Leads/EqTestLeads";
import EnglishEmotion from "../pages/Leads/EnglishEmotion";
import PaymentBonus from "../pages/Leads/PaymentBonus";
import BengaliBlsFreeLeads from "../pages/Leads/BengaliBlsFree";
import FreeAffirmationLead from "../pages/Leads/FreeAffirmationLead";
import EnglishBLSPaidLeads from "../pages/Leads/EnglishBlsPaid";
import HealthBengali from "../pages/Leads/HealthBengali";
import BlsEngFreeLeads from "../pages/Leads/BLSEngFreeLeads";
import OldEnglishBlsLead from "../pages/Leads/OldEnglishBlsLead";
import BengaliBlsPaid from "../pages/Leads/BengaliBlsPaid";
import SlsEnglishPaid from "../pages/Leads/SlsEnglishPaid";
import BengaliMoneyLeads from "../pages/Leads/BengaliMoneyLeads";
import EnglishMoneyLeads from "../pages/Leads/EnglishMoney";
import LionsDay from "../pages/Leads/LionsDay";
import ParentingLeads from "../pages/Leads/ParentingLeads";
import StressManagement from "../pages/Leads/StressManagementLeads";
import ManifestationLeads from "../pages/Leads/ManifestationLeads";
import BlsGraduateLeads from "../pages/Leads/BLSGraduateLeads";
import StressIntroLeads from "../pages/Leads/StressIntroLeads";
import BengaliFreeLeads from "../pages/Leads/BengaliFreeLeads";
import DailyMeditationLeads from "../pages/Leads/DailyMeditationLeads";
import StressBngPaidLead from "../pages/Leads/StressBngPaidLead";
import SlsBngIntro from "../pages/Leads/SlsBngIntro";
import ConsultancyLeads from "../pages/Leads/ConsultancyLeads";
import Dashboard from "../pages/dashboard/Dashboard";
import ChronicHealing from "../pages/Leads/ChronicHealing";
import BlsEngBrochureLeads from "../pages/Leads/BlsEngBrochreDownLead";
import MoneyBengLeads from "../pages/Leads/MoneyBengLeads";
import LiveGuidedHelaing from "../pages/Leads/LiveGuidedHelaing";
import IntroMasterClassLeads from "../pages/Leads/IntroMasterClassLeads";
import WomensdayEng from "../pages/Leads/WomensdayEng";
import WomensDayBeng from "../pages/Leads/WomensDayBeng";
import Instructors from "../pages/Instructors/Instructors";
import StressBngFree from "../pages/Leads/StressBngFree";
import MoneyManagementEng from "../pages/Leads/MoneyManagementEng";
import LawofAttraction from "../pages/Leads/LawofAttraction";
import MindBodyHealing from "../pages/Leads/MindBodyHealing";
import ChakraHealing from "../pages/Leads/ChakraHealing";
import ChakraQuiz from "../pages/Leads/ChakraQuiz";
import SilvaDurgapur from "../pages/Leads/SilvaDurgapur";
import Freebie from "../pages/Leads/Freebie";
import VisionBoards from "../pages/Leads/VisionBoards";
import HealingProblemSolving from "../pages/Leads/HealingProblemSolving";
import ShadowWork from "../pages/Leads/ShadowWork";
import HelaingQuiz from "../pages/Leads/HealingQuiz";
import SubconsciousQuizLeads from "../pages/Leads/SubconsciousQuizLeads";
import UpcomingMasterClasses from "../pages/Classes/UpcomingClasses";
import TestPayment from "../pages/TestPayment/TestPayment";
import MumbaiTickets from "../pages/Tickets/MumbaiTickets";
import ScanTicket from "../pages/Tickets/ScanTicket";
import AddTicketPage from "../pages/Tickets/AddTicket";
import Testimonials from "../pages/Testimonials/Testimonials";
import FreeMeditationLead from "../pages/Leads/FreeMeditationLead";
import ManageLead from "../pages/Leads/ManageLead";
import AllLeads from "../pages/Leads/manageLead/AllLeads";
import LeadDetails from "../pages/Leads/manageLead/LeadDetails";
import UpcomingWorkshops from "../pages/workshops/UpcomingWorkshops";
import GoaUsers from "../pages/Leads/GoaUsers";
import Feedbacks from "../pages/Leads/Feedbacks";


const AllRoutes = () => {

  return (

    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/test-payment" element={<TestPayment />} />
      <Route path="/manage-lead" element={<AllLeads />} />
      <Route path="/manage-lead/:leadId" element={<LeadDetails />} />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardLayout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/:course_id/chapters" element={<Chapters />} />
                <Route path="/:course_id/:chapter_id/lessons" element={<Lessons />} />
                <Route path="/classes" element={<Classes />} />
                <Route path="/events" element={<Events />} />
                <Route path="/coupons" element={<Coupons />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/queries" element={<QueryLeads />} />
                <Route path="/eqleads" element={<EqTestLeads />} />
                <Route path="/eng-emotion-leads" element={<EnglishEmotion />} />
                <Route path="/paymentbonus-download-leads" element={<PaymentBonus />} />
                <Route path="/bls-bengali-free-leads" element={<BengaliBlsFreeLeads />} />
                <Route path="/free-affirmation-leads" element={<FreeAffirmationLead />} />
                <Route path="/bls-eng-paid-leads" element={<EnglishBLSPaidLeads />} />
                <Route path="/bls-eng-free-leads" element={<BlsEngFreeLeads />} />
                <Route path="/old-eng-bls-free-leads" element={<OldEnglishBlsLead />} />
                <Route path="/health-bng-paid-leads" element={<HealthBengali />} />
                <Route path="/bls-bng-paid-leads" element={<BengaliBlsPaid />} />
                <Route path="/sls-eng-paid-leads" element={<SlsEnglishPaid />} />
                <Route path="/bng-money-leads" element={<BengaliMoneyLeads />} />
                <Route path="/eng-money-leads" element={<EnglishMoneyLeads />} />
                <Route path="/lions-day-leads" element={<LionsDay />} />
                <Route path="/parenting-leads" element={<ParentingLeads />} />
                <Route path="/stress-management-leads" element={<StressManagement />} />
                <Route path="/manifestation-leads" element={<ManifestationLeads />} />
                <Route path="/bls-graduate-leads" element={<BlsGraduateLeads />} />
                <Route path="/stress-intro-leads" element={<StressIntroLeads />} />
                <Route path="/bng-free-leads" element={<BengaliFreeLeads />} />
                <Route path="/daily-meditation-leads" element={<DailyMeditationLeads />} />
                <Route path="/stress-bng-paid-leads" element={<StressBngPaidLead />} />
                <Route path="/sls-bng-intro-leads" element={<SlsBngIntro />} />
                <Route path="/consultancy-leads" element={<ConsultancyLeads />} />
                <Route path="/chronic-healing-leads" element={<ChronicHealing />} />
                <Route path="/bls-eng-brochure-leads" element={<BlsEngBrochureLeads />} />
                <Route path="/money-bengali-new-leads" element={<MoneyBengLeads />} />
                <Route path="/live-guided-healing-leads" element={<LiveGuidedHelaing />} />
                <Route path="/intro-masterclass-leads" element={<IntroMasterClassLeads />} />
                <Route path="/womensday-eng-leads" element={<WomensdayEng />} />
                <Route path="/womensday-beng-leads" element={<WomensDayBeng />} />
                <Route path="/stress-beng-free-leads" element={<StressBngFree />} />
                <Route path="/new-money-manifestation-eng-leads" element={<MoneyManagementEng />} />
                <Route path="/law-of-attraction-leads" element={<LawofAttraction />} />
                <Route path="/mind-body-healing-leads" element={<MindBodyHealing />} />
                <Route path="/chakra-healing" element={<ChakraHealing />} />
                <Route path="/chakra-quiz" element={<ChakraQuiz />} />
                <Route path="/silva-in-durgapur" element={<SilvaDurgapur />} />
                <Route path="/free-bie" element={<Freebie />} />
                <Route path="/vision-boards" element={<VisionBoards />} />
                <Route path="/healing-problem-solving" element={<HealingProblemSolving />} />
                <Route path="/shadow-work" element={<ShadowWork />} />
                <Route path="/healing-quiz" element={<HelaingQuiz />} />
                <Route path="/free-meditation-leads" element={<FreeMeditationLead />} />
                <Route path="/instructors" element={<Instructors />} />
                <Route path="/subconscious-quiz-leads" element={<SubconsciousQuizLeads />} />
                <Route path="/create-ticket" element={<AddTicketPage />} />
                <Route path="/tickets" element={<MumbaiTickets />} />
                <Route path="/scan-ticket" element={<ScanTicket />} />
                <Route path="/upcoming-masterclasses" element={<UpcomingMasterClasses />} />
                <Route path="/upcoming-workshops" element={<UpcomingWorkshops />} />
                <Route path="/testimonials" element={<Testimonials />} />
                 <Route path="/goa-users" element={<GoaUsers />} />
                 <Route path="/goa-users-feedbacks" element={<Feedbacks />} />
              </Routes>
            </DashboardLayout>
          </PrivateRoute>
        }
      />
    </Routes>

  );
};


export default AllRoutes